// @generated by protoc-gen-es v2.10.2 with parameter "target=js+dts,import_extension=none"
// @generated from file reports/v1/reports.proto (package reports.v1, syntax proto3)
/* eslint-disable */

import { fileDesc, messageDesc, serviceDesc } from "@bufbuild/protobuf/codegenv2";

/**
 * Describes the file reports/v1/reports.proto.
 */
export const file_reports_v1_reports = /*@__PURE__*/
  fileDesc("ChhyZXBvcnRzL3YxL3JlcG9ydHMucHJvdG8SCnJlcG9ydHMudjEiVQoZR2V0U3BlbmRpbmdTdW1tYXJ5UmVxdWVzdBIRCgR5ZWFyGAEgASgFSACIAQESEgoFbW9udGgYAiABKAVIAYgBAUIHCgVfeWVhckIICgZfbW9udGgikwMKGkdldFNwZW5kaW5nU3VtbWFyeVJlc3BvbnNlEjEKDmN1cnJlbnRfcGVyaW9kGAEgASgLMhkucmVwb3J0cy52MS5QZXJpb2RTdW1tYXJ5EjIKD3ByZXZpb3VzX3BlcmlvZBgCIAEoCzIZLnJlcG9ydHMudjEuUGVyaW9kU3VtbWFyeRIxCg5kYWlseV9zcGVuZGluZxgDIAMoCzIZLnJlcG9ydHMudjEuRGFpbHlTcGVuZGluZxIxCg5zdG9yZV9zcGVuZGluZxgEIAMoCzIZLnJlcG9ydHMudjEuU3RvcmVTcGVuZGluZxIvCg1vdmVyYWxsX3N0YXRzGAUgASgLMhgucmVwb3J0cy52MS5PdmVyYWxsU3RhdHMSQgoXcGF5bWVudF9tZXRob2Rfc3BlbmRpbmcYBiADKAsyIS5yZXBvcnRzLnYxLlBheW1lbnRNZXRob2RTcGVuZGluZxIzChBtb250aGx5X3NwZW5kaW5nGAcgAygLMhkucmVwb3J0cy52MS5QZXJpb2RTdW1tYXJ5IlIKDVBlcmlvZFN1bW1hcnkSDAoEeWVhchgBIAEoBRINCgVtb250aBgCIAEoBRINCgV0b3RhbBgDIAEoARIVCg1yZWNlaXB0X2NvdW50GAQgASgFIkIKDURhaWx5U3BlbmRpbmcSCwoDZGF5GAEgASgFEg0KBXRvdGFsGAIgASgBEhUKDXJlY2VpcHRfY291bnQYAyABKAUiRAoNU3RvcmVTcGVuZGluZxINCgVzdG9yZRgBIAEoCRINCgV0b3RhbBgCIAEoARIVCg1yZWNlaXB0X2NvdW50GAMgASgFIlUKFVBheW1lbnRNZXRob2RTcGVuZGluZxIWCg5wYXltZW50X21ldGhvZBgBIAEoCRINCgV0b3RhbBgCIAEoARIVCg1yZWNlaXB0X2NvdW50GAMgASgFIsIBCgxPdmVyYWxsU3RhdHMSFgoOdG90YWxfcmVjZWlwdHMYASABKAUSGwoTcmVjZWlwdHNfd2l0aF9kYXRlcxgCIAEoBRIVCg11bmlxdWVfc3RvcmVzGAMgASgFEhkKEWF2ZXJhZ2VfcGVyX21vbnRoGAQgASgBEhYKDnRvdGFsX3NwZW5kaW5nGAUgASgBEhoKEnVucmVjb25jaWxlZF9jb3VudBgGIAEoBRIXCg90b3RhbF9kaXNjb3VudHMYByABKAEydQoOUmVwb3J0c1NlcnZpY2USYwoSR2V0U3BlbmRpbmdTdW1tYXJ5EiUucmVwb3J0cy52MS5HZXRTcGVuZGluZ1N1bW1hcnlSZXF1ZXN0GiYucmVwb3J0cy52MS5HZXRTcGVuZGluZ1N1bW1hcnlSZXNwb25zZUKlAQoOY29tLnJlcG9ydHMudjFCDFJlcG9ydHNQcm90b1ABWjxnaXRodWIuY29tL3N1YnRvdGFsLWlvL2dyb2NlcmFwaS9nZW4vZ28vcmVwb3J0cy92MTtyZXBvcnRzdjGiAgNSWFiqAgpSZXBvcnRzLlYxygIKUmVwb3J0c1xWMeICFlJlcG9ydHNcVjFcR1BCTWV0YWRhdGHqAgtSZXBvcnRzOjpWMWIGcHJvdG8z");

/**
 * Describes the message reports.v1.GetSpendingSummaryRequest.
 * Use `create(GetSpendingSummaryRequestSchema)` to create a new message.
 */
export const GetSpendingSummaryRequestSchema = /*@__PURE__*/
  messageDesc(file_reports_v1_reports, 0);

/**
 * Describes the message reports.v1.GetSpendingSummaryResponse.
 * Use `create(GetSpendingSummaryResponseSchema)` to create a new message.
 */
export const GetSpendingSummaryResponseSchema = /*@__PURE__*/
  messageDesc(file_reports_v1_reports, 1);

/**
 * Describes the message reports.v1.PeriodSummary.
 * Use `create(PeriodSummarySchema)` to create a new message.
 */
export const PeriodSummarySchema = /*@__PURE__*/
  messageDesc(file_reports_v1_reports, 2);

/**
 * Describes the message reports.v1.DailySpending.
 * Use `create(DailySpendingSchema)` to create a new message.
 */
export const DailySpendingSchema = /*@__PURE__*/
  messageDesc(file_reports_v1_reports, 3);

/**
 * Describes the message reports.v1.StoreSpending.
 * Use `create(StoreSpendingSchema)` to create a new message.
 */
export const StoreSpendingSchema = /*@__PURE__*/
  messageDesc(file_reports_v1_reports, 4);

/**
 * Describes the message reports.v1.PaymentMethodSpending.
 * Use `create(PaymentMethodSpendingSchema)` to create a new message.
 */
export const PaymentMethodSpendingSchema = /*@__PURE__*/
  messageDesc(file_reports_v1_reports, 5);

/**
 * Describes the message reports.v1.OverallStats.
 * Use `create(OverallStatsSchema)` to create a new message.
 */
export const OverallStatsSchema = /*@__PURE__*/
  messageDesc(file_reports_v1_reports, 6);

/**
 * ReportsService provides spending analytics and reporting.
 *
 * @generated from service reports.v1.ReportsService
 */
export const ReportsService = /*@__PURE__*/
  serviceDesc(file_reports_v1_reports, 0);

